<template>
	<v-btn
		v-if="!isOniOSApp"
		depressed
		dark
		block
		large
		class="mx-auto mb-4 microsoft-sign-in-btn"
		color="#0078d4"
		data-testid="microsoftLoginButton"
		:disabled="!isReady"
		:loading="loading"
		@click="onMicrosoftLogin"
	>
		<v-icon size="20px" class="mr-3">mdi-microsoft</v-icon>
		<span class="font-weight-black fs15 microsoft-sign-in-btn__label">Connexion avec Microsoft</span>
	</v-btn>
</template>

<script>
import { detectIosApp } from '../utils/helper';
import { ensureMsalRedirectHandled, loginWithMicrosoft } from '../utils/microsoftAuth';

export default {
	name: 'MicrosoftSignInButton',
	data: () => ({
		loading: false,
		isReady: false,
		isOniOSApp: detectIosApp(),
	}),
	async created() {
		try {
			await ensureMsalRedirectHandled();
		} catch (error) {
			console.error('[Microsoft Auth] MSAL redirect handling failed:', error);
			this.$emit('error', error);
		} finally {
			this.isReady = true;
		}
	},
	methods: {
		async onMicrosoftLogin() {
			if (!this.isReady || this.loading) return;

			try {
				this.loading = true;
				await loginWithMicrosoft();
			} catch (error) {
				console.error('[Microsoft Auth] Login redirect failed:', error);
				this.loading = false;
				this.$emit('error', error);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.microsoft-sign-in-btn {
	min-height: 44px;
	height: auto !important;
	padding-top: 8px !important;
	padding-bottom: 8px !important;
}

.microsoft-sign-in-btn__label {
	white-space: normal;
	line-height: 1.2;
	text-align: center;
}

.fs15 {
	font-size: 15px;
}

@media screen and (max-width: 360px) {
	.microsoft-sign-in-btn__label {
		font-size: 13px;
	}
}
</style>
